import {
  commitHomepageCarouselDisplay,
  type CommitHomepageCarouselDisplayInput,
  type HomepageCarouselDisplayDecision,
  type HomepageOfferClaimMaps,
} from './homepageOfferCarouselDeduplication'

export interface HomepageOfferClaimStore {
  claim: (input: CommitHomepageCarouselDisplayInput) => HomepageCarouselDisplayDecision
}

export function createHomepageOfferClaimStore(): HomepageOfferClaimStore {
  const maps: HomepageOfferClaimMaps = {
    claimedIds: new Set(),
    ownedByCarousel: new Map(),
  }

  return {
    claim: (input) => commitHomepageCarouselDisplay(maps, input),
  }
}
